import { render } from "./ProductReview.vue?vue&type=template&id=af09d568&scoped=true"
import script from "./ProductReview.vue?vue&type=script&lang=js"
export * from "./ProductReview.vue?vue&type=script&lang=js"

import "./ProductReview.vue?vue&type=style&index=0&id=af09d568&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af09d568"]])

export default __exports__